import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroApp } from '../../Components/Home/hero-app/hero-app';
import { ProductApp } from '../../Components/Home/product-app/product-app';
import { SeoService } from '../../Shared/seo/seo.service';

@Component({
  selector: 'app-product-page',
  standalone: true,
  imports: [CommonModule, HeroApp, ProductApp],
  templateUrl: './product-page.html',
  styles: [`
    #hero {
      padding: 20px 0 10px;
    }
  `],
})
export class ProductPageComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.update({
      title: 'Choose Your Apps — Get Started Free',
      description:
        'Pick the orderYaa ERP modules your business needs and get started free — unlimited users, no credit card required.',
      path: '/product',
    });
  }
}
